export default {"src":"/_next/static/media/video-solution.efc080e8.svg","height":316,"width":383,"blurWidth":0,"blurHeight":0};